import { version as appVersion } from "../../package.json"
import { useAppUpdateNotice } from "@/hooks/use-app-update-notice"

export function AppUpdateNotice() {
  useAppUpdateNotice(appVersion)
  return null
}
